import { problem as problemAPI } from '../api'

export const problem = {
  reportProblem(problemRequest) {
    return dispatch => {
      return dispatch(problemAPI.reportProblem(problemRequest))
    }
  },
}
